import Group from 'src/entities/Group';

import Environment from '../common/Environment';
import Member from '../entities/Member';
import Memo from '../entities/Memo';
import MemosJson from '../jsons/MemosJson';

export default class GetMemosGroup {
  execute(
    group: Group,
    offset: number,
    limit: number,
    account: Member
  ): Promise<Memo[]> {
    const method: string = 'GET';
    const path: string = Environment.server() + '/memos/group/' + group.id;

    return new Promise((resolve, reject) => {
      const request = new URL(path);
      const params = new URLSearchParams();
      params.append('t', account.token);
      params.append('offset', String(offset));
      params.append('limit', String(limit));
      request.search = params.toString();

      fetch(request.toString(), {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: MemosJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.memos);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/GetMemosGroup.ts